export const centredSquare = ({ x, y, width, height }) => {
  const side = Math.min(width, height);

  return {
    x: x + Math.floor((width - side) / 2),
    y: y + Math.floor((height - side) / 2),
    width: side,
    height: side,
  };
};
